export default "__VITE_ASSET__DU7nA45t__"